import { inject, ChangeDetectorRef, Component, Inject, Input, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { RestClient } from "../../../Api/DcoApi/Client/RestClient";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { Splash } from "../../../Akte/Controlls/Splash";
import { Leitstelle } from "../../../Api/DcoApi/AktenEintraege/Leitstelle";
import { Artikel } from "../../../Api/DcoApi/Admin/AdminClasses2";
import { ToastService } from "../../../Akte/Services/Toasts/ToastService";
import { AdminCard } from "../Sonstige/AdminCard";
import { PreisHist } from "../../Popups/PreisHist";
import { PriceEdit } from "../../Popups/PriceEdit";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap/modal";


@Component({
  imports: [
    CommonModule,
    Splash,
    FormsModule,
    AdminCard
  ],
  selector: 'ArtikelEdit',
  templateUrl: './ArtikelEdit.html',
  standalone: true,
  styleUrl: './ArtikelEdit.css'
})
export class ArtikelEdit implements OnInit {
  toastService: ToastService ; 
  ngOnInit(): void {
    this.GetData();
  }

  constructor(private cdr: ChangeDetectorRef) {
    this.toastService = inject(ToastService)
  }

  @Input() Key?: string | null = null;

  Client: RestClient = new RestClient();

  Entry: Artikel | null = null;

  async GetData() {
    if (!this.Key || this.Key == null || this.Key == "0" || isNaN(Number(this.Key)))
      this.Entry = { key: 0 } as Artikel;
    else
      this.Entry = await this.Client.Get<Artikel>(`/Backend/Api/V2/Admin/Artikel/${this.Key}`);

    this.cdr.detectChanges();
  }


  private modalService = inject(NgbModal);

  UpdatePreis() {
    if (!this.Entry || this.Entry == null)
      return;

    var modal = this.modalService.open(PriceEdit)
    modal.componentInstance.url = `/Backend/Api/V2/Admin/Artikel/${this.Key}/Preis`;
    modal.componentInstance.header = 'Preis';
    modal.componentInstance.labelText = 'Preis';
    modal.componentInstance.CurrentPrice = this.Entry.preis;

    modal.closed.subscribe({
      next: async (legs) => {
        if (legs && legs != null) {
          if (!(!this.Entry || this.Entry == null)) {
            this.Entry.preis = legs.preis;
            var entry = await await await this.Client.Get<Artikel>(`/Backend/Api/V2/Admin/Artikel/${this.Key}`);
            this.Entry.preisHistorie = entry.preisHistorie;
            this.cdr.detectChanges();
          }

        }
      },
      error: (err) => {

      },
    });
  }

  OpenPreisHistory() {
    if (!this.Entry || this.Entry == null || !this.Entry.preisHistorie || this.Entry.preisHistorie == null)
      return;
    var modal = this.modalService.open(PreisHist)
    modal.componentInstance.Items = this.Entry.preisHistorie;
    modal.componentInstance.header = 'Historie';
    modal.componentInstance.labelText = 'Rate';

    modal.closed.subscribe({
      next: async (config) => {

      },
      error: (err) => {


      },
    });
  }

  async SaveData() {
    if (this.Entry && this.Entry !== null) {
      if (this.Entry.key == 0)
        this.Entry = await this.Client.Post<Artikel, Artikel>("/Backend/Api/V2/Admin/Artikel", this.Entry);
      else
        this.Entry = await this.Client.Put<Artikel, Artikel>(`/Backend/Api/V2/Admin/Leitstelle`, this.Entry);

      this.toastService.show({ template: this.successTpl, classname: 'bg-success text-light show', delay: 10000 })
    }
  }
  @ViewChild('successTpl') public successTpl!: TemplateRef<any>;
}
